import { jsPDF as JsPDF } from "jspdf"
import autoTable from "jspdf-autotable"
import JsBarcode from "jsbarcode"

// ============================================================================
// 1. NUEVA FUNCIÓN: IMPRESIÓN DIRECTA POR BLUETOOTH (ZPL II)
// ============================================================================
export const handlePrintPesajeTicketBluetooth = async (formData, detalles, infoHome) => {
  try {
    if (!navigator.bluetooth) {
      throw new Error("Su navegador no soporta Web Bluetooth (Ej: Safari en iOS).")
    }

    const alias = infoHome?.ciaalias || "SISTEMA SIAC"
    const fechaGeneracion = new Date().toLocaleString()
    const pesoid = formData?.pesoid || "NUEVO"

    // CONSTRUCCIÓN DEL TICKET EN LENGUAJE ZPL II (Específico para Honeywell/Zebra)
    let zpl = `^XA
^PW640
^CI28
^FX --- ENCABEZADO ---
^FO0,30^FB640,1,0,C^A0N,35,35^FD${alias}^FS
^FO0,70^FB640,1,0,C^A0N,25,25^FDTICKET DE BASCULA - PESAJE^FS
^FO20,110^GB600,2,2^FS

^FX --- CODIGO BARRAS ---
^FO120,130^BY3^BCN,80,Y,N,N^FD${pesoid}^FS

^FX --- DATOS GENERALES ---
^FO20,240^A0N,22,22^FDFecha: ${fechaGeneracion}^FS
^FO20,270^A0N,22,22^FDProveedor: ${formData?.procodigo || ""} - ${formData?.pronombre || ""}^FS
^FO20,300^A0N,22,22^FDProducto: ${formData?.artdescri || ""}^FS
^FO20,330^A0N,22,22^FDPrecio Sug.: $${Number(formData?.pesoprecio || 0).toFixed(4)}^FS
^FO20,360^GB600,2,2^FS

^FX --- DETALLE DE PESOS ---
^FO20,380^A0N,25,25^FDDETALLE DE PESOS^FS
^FO20,410^A0N,22,22^FD#   Peso Registrado^FS
`

    let currentY = 440
    ;(detalles || []).forEach((d, i) => {
      zpl += `^FO20,${currentY}^A0N,22,22^FD${d.pesosecuen || i + 1}^FS`
      zpl += `^FO150,${currentY}^A0N,22,22^FD${Number(d.pesocantidad || 0).toFixed(2)} lbs^FS\n`
      currentY += 30
    })

    // RESUMEN DE LIQUIDACIÓN
    currentY += 10
    zpl += `^FO20,${currentY}^GB600,2,2^FS\n`
    currentY += 20
    zpl += `^FO20,${currentY}^A0N,25,25^FDRESUMEN DE LIQUIDACION^FS\n`

    currentY += 35
    zpl += `^FO20,${currentY}^A0N,22,22^FDLbs Brutas: ${Number(formData?.pesocantbruta || 0).toFixed(2)}^FS`
    zpl += `^FO320,${currentY}^A0N,22,22^FDSubtotal: $${Number(formData?.pesovalbruto || 0).toFixed(2)}^FS\n`

    currentY += 30
    zpl += `^FO20,${currentY}^A0N,22,22^FD(-) Humedad: ${Number(formData?.pesohumecantidad || 0).toFixed(2)}^FS`
    zpl += `^FO320,${currentY}^A0N,22,22^FD(-) Retencion: $${Number(formData?.pesoretenvalor || 0).toFixed(2)}^FS\n`

    currentY += 35
    zpl += `^FO20,${currentY}^A0N,24,24^FD(=) Lbs Netas: ${Number(formData?.pesocantfinal || 0).toFixed(2)}^FS`
    zpl += `^FO320,${currentY}^A0N,24,24^FDTOTAL PAGAR: $${Number(formData?.pesovaltot || 0).toFixed(2)}^FS\n`

    zpl += `\n^XZ`

    // CONEXIÓN BLUETOOTH
    const device = await navigator.bluetooth.requestDevice({
      filters: [{ namePrefix: "LNX" }],
      optionalServices: [
        "000018f0-0000-1000-8000-00805f9b34fb",
        "e7810a71-73ae-499d-8c15-faa9aef0c3f2",
        "49535343-fe7d-4ae5-8fa9-9fafd205e455",
      ],
    })

    const server = await device.gatt.connect()
    const services = await server.getPrimaryServices()
    let writeCharacteristic = null

    for (const service of services) {
      const characteristics = await service.getCharacteristics()
      for (const char of characteristics) {
        if (char.properties.write || char.properties.writeWithoutResponse) {
          writeCharacteristic = char
          break
        }
      }
      if (writeCharacteristic) break
    }

    if (!writeCharacteristic) throw new Error("No se pudo establecer un canal de escritura con la impresora.")

    const encoder = new TextEncoder()
    const data = encoder.encode(zpl)
    const CHUNK_SIZE = 100

    for (let i = 0; i < data.length; i += CHUNK_SIZE) {
      const chunk = data.slice(i, i + CHUNK_SIZE)
      if (writeCharacteristic.properties.writeWithoutResponse) {
        await writeCharacteristic.writeValueWithoutResponse(chunk)
      } else {
        await writeCharacteristic.writeValue(chunk)
      }
    }

    // CORRECCIÓN ESLINT: Retornamos en lugar de usar resolve()
    return true
  } catch (error) {
    console.warn("Fallo impresión Bluetooth, retornando error para Fallback:", error)
    // CORRECCIÓN ESLINT: Lanzamos el error en lugar de usar reject()
    throw error
  }
}

// ============================================================================
// 2. FUNCIÓN ORIGINAL: RESPALDO EN PDF (Mantenida intacta como Fallback)
// ============================================================================
export const handlePrintPesajeTicket = (formData, detalles, infoHome) => {
  // Configuración para papel de impresora térmica/portátil (Ancho: 112mm, Alto: 135mm)
  const doc = new JsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [112, 135],
  })

  const alias = infoHome?.ciaalias || "SISTEMA SIAC"

  // 1. ENCABEZADO CENTRADO
  doc.setFontSize(12)
  doc.setFont("helvetica", "bold")
  doc.text(alias, 56, 12, { align: "center" })

  doc.setFontSize(10)
  doc.text("TICKET DE BÁSCULA - PESAJE", 56, 18, { align: "center" })

  doc.setLineWidth(0.3)
  doc.line(5, 22, 107, 22)

  // 2. GENERACIÓN DE CÓDIGO DE BARRAS
  if (formData?.pesoid) {
    try {
      const canvas = document.createElement("canvas")
      JsBarcode(canvas, formData.pesoid, {
        format: "CODE128",
        displayValue: false,
        margin: 0,
      })
      const barcodeData = canvas.toDataURL("image/jpeg")
      doc.addImage(barcodeData, "JPEG", 26, 24, 60, 10)
    } catch (error) {
      console.warn("Error generando el código de barras:", error)
    }
  }

  // 3. DATOS GENERALES
  let startY = 38
  doc.setFontSize(8)

  doc.setFont("helvetica", "bold")
  doc.text("Nº Pesaje:", 5, startY)
  doc.setFont("helvetica", "normal")
  doc.text(formData?.pesoid || "", 25, startY)

  doc.setFont("helvetica", "bold")
  doc.text("Fecha:", 56, startY)
  doc.setFont("helvetica", "normal")
  const fechaGeneracion = new Date().toLocaleString()
  doc.text(fechaGeneracion, 70, startY)

  doc.setFont("helvetica", "bold")
  doc.text("Proveedor:", 5, startY + 6)
  doc.setFont("helvetica", "normal")
  const provText = doc.splitTextToSize(`${formData?.procodigo || ""} - ${formData?.pronombre || ""}`, 80)
  doc.text(provText, 25, startY + 6)

  startY += 6 + provText.length * 4

  doc.setFont("helvetica", "bold")
  doc.text("Producto:", 5, startY)
  doc.setFont("helvetica", "normal")
  const prodText = doc.splitTextToSize(formData?.artdescri || "", 80)
  doc.text(prodText, 25, startY)

  startY += 2 + prodText.length * 4

  doc.setFont("helvetica", "bold")
  doc.text("Precio Sug.:", 5, startY)
  doc.setFont("helvetica", "normal")
  doc.text(`$${Number(formData?.pesoprecio || 0).toFixed(4)}`, 25, startY)

  startY += 4
  doc.line(5, startY, 107, startY)

  // 4. TABLA DE DETALLE DE PESOS
  startY += 4
  doc.setFont("helvetica", "bold")
  doc.text("DETALLE DE PESOS", 5, startY)

  const tableBody = (detalles || []).map((d, i) => [
    d.pesosecuen || i + 1,
    `${Number(d.pesocantidad || 0).toFixed(2)} lbs`,
  ])

  autoTable(doc, {
    startY: startY + 2,
    head: [["#", "Peso Registrado"]],
    body: tableBody,
    theme: "plain",
    styles: { fontSize: 8, cellPadding: 1 },
    headStyles: { fontStyle: "bold", halign: "center", borderBottom: "1px solid #000" },
    columnStyles: { 0: { halign: "center" }, 1: { halign: "right" } },
    margin: { left: 5, right: 5 },
  })

  // 5. CUADRO DE LIQUIDACIÓN
  let finalY = doc.lastAutoTable.finalY + 5

  if (finalY > 105) {
    doc.addPage()
    finalY = 10
  }

  doc.line(5, finalY, 107, finalY)
  finalY += 4

  doc.setFont("helvetica", "bold")
  doc.text("RESUMEN DE LIQUIDACIÓN", 5, finalY)

  doc.setFontSize(8)
  finalY += 6

  doc.setFont("helvetica", "normal")
  doc.text("Libras Brutas:", 5, finalY)
  doc.text(Number(formData?.pesocantbruta || 0).toFixed(2), 35, finalY, { align: "right" })

  doc.text("(-) Humedad:", 5, finalY + 4)
  doc.text(Number(formData?.pesohumecantidad || 0).toFixed(2), 35, finalY + 4, { align: "right" })

  doc.setFont("helvetica", "bold")
  doc.text("(=) Lbs Netas:", 5, finalY + 8)
  doc.text(Number(formData?.pesocantfinal || 0).toFixed(2), 35, finalY + 8, { align: "right" })

  doc.setFont("helvetica", "normal")
  doc.text("Subtotal:", 56, finalY)
  doc.text(`$${Number(formData?.pesovalbruto || 0).toFixed(2)}`, 105, finalY, { align: "right" })

  doc.text("(-) Retención:", 56, finalY + 4)
  doc.text(`$${Number(formData?.pesoretenvalor || 0).toFixed(2)}`, 105, finalY + 4, { align: "right" })

  doc.setFont("helvetica", "bold")
  doc.setFontSize(9)
  doc.text("TOTAL A PAGAR:", 56, finalY + 10)
  doc.text(`$${Number(formData?.pesovaltot || 0).toFixed(2)}`, 105, finalY + 10, { align: "right" })

  window.open(doc.output("bloburl"), "_blank")
}
